/**
 * ç¨äºå¤ç«¯ä¹é´ä½¿ç¨ï¼åºåå½åæå±ç«¯å
 */
export class NecProject {
  static NAME = ''
}
